import * as R from 'ramda';

const renameKeys = R.curry((fn, obj) =>
  // @ts-ignore
  R.fromPairs(R.map(R.adjust(fn, 0), R.toPairs(obj))),
);

export default renameKeys;
